<template>
  <div>
    <b-loading :is-full-page="true" :active="!initialized"></b-loading>
    <section v-if="initialized" class="section is-main-section">
      <CardComponent>
        <div class="section has-text-centered">
          <h1 class="title">
            {{ added ? 'Create New Organisation' : 'Edit Organisation' }}
          </h1>
        </div>
        <div class="columns is-vcentered">
          <div class="column is-6 is-offset-3">
            <div class="flex-card light-bordered light-raised">
              <div class="card-body">
                <ValidationObserver ref="observer" v-slot="{ passes }">
                  <form @submit.prevent="passes(submit)">
                    <div class="columns is-multiline">
                      <div class="column is-12">
                        <div class="control">
                          <ValidationProvider
                            v-slot="{ errors }"
                            name="Name"
                            rules="required"
                          >
                            <b-field
                              label="Name"
                              :type="{ 'is-danger': errors.length > 0 }"
                              :message="errors[0]"
                            >
                              <b-input v-model="item.name" />
                            </b-field>
                          </ValidationProvider>
                        </div>
                      </div>
                    </div>
                    <div class="has-text-centered">
                      <div class="is-block has-margin-bottom-15">
                        <b-button
                          icon-left="arrow-left"
                          class="is-medium has-margin-right-10"
                          tag="router-link"
                          :to="{
                            name: 'ManageOrganisations'
                          }"
                        >
                          Back to List</b-button
                        >
                        <button
                          class="button is-primary is-medium btn-align no-lh raised primary-btn"
                          type="submit"
                          :disabled="loading"
                          :class="{ 'is-loading': loading }"
                        >
                          {{ added ? 'Create' : 'Update' }}
                        </button>
                      </div>
                    </div>
                  </form>
                </ValidationObserver>
              </div>
            </div>
          </div>
        </div>
      </CardComponent>
    </section>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import CardComponent from '@/components/CardComponent'
import OrganisationApi from '@/api/organisations'

export default {
  name: 'EditOrganisation',
  components: {
    CardComponent
  },
  metaInfo: {
    title: 'Edit Organisation'
  },
  computed: {
    ...mapGetters(['user'])
  },
  watch: {
    async $route() {
      if (!this.added) {
        this.item = await OrganisationApi.get(this.$route.params.id)
      }
    }
  },
  async mounted() {
    this.added = this.$route.name === 'CreateOrganisation' ? true : false
    if (!this.added) {
      this.item = await OrganisationApi.get(this.$route.params.id)
    }
    this.initialized = true
  },
  data() {
    return {
      loading: false,
      initialized: false,
      added: false,
      item: {}
    }
  },
  methods: {
    ...mapActions(['getUser']),
    async submit() {
      this.loading = true
      if (!this.item.id) {
        await OrganisationApi.create(this.item)
        this.$buefy.toast.open({
          message: 'Organisation created successfully!',
          position: 'is-top',
          type: 'is-success'
        })
        this.$router.push({
          name: 'ManageOrganisations'
        })
        this.loading = false
      } else {
        this.item.organisationId = this.item.id
        await OrganisationApi.update(this.item)
        this.$buefy.toast.open({
          message: 'Organisation updated successfully!',
          position: 'is-top',
          type: 'is-success'
        })
        this.loading = false
      }
    }
  }
}
</script>
